import { useState } from "react";
import { toast } from "sonner";
import { Pencil } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { api, formatApiError } from "@/lib/api";
import { Field, SubmitButton } from "@/components/site/FormBits";

export const ProfileCard = () => {
  const { user, setUser } = useAuth();
  const [editing, setEditing] = useState(false);
  const [form, setForm] = useState({ full_name: user.full_name, phone: user.phone || "" });
  const [loading, setLoading] = useState(false);

  const save = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.put("/auth/profile", { full_name: form.full_name, phone: form.phone || null });
      setUser(data);
      setEditing(false);
      toast.success("Your details have been updated");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  if (!editing) {
    return (
      <section data-testid="profile-card" className="mt-10 bg-white border border-[#E4E1D9] p-6 flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <dl className="grid sm:grid-cols-3 gap-4 sm:gap-10 text-sm">
          <div><dt className="eyebrow">Name</dt><dd className="mt-1" data-testid="profile-name">{user.full_name}</dd></div>
          <div><dt className="eyebrow">Email</dt><dd className="mt-1" data-testid="profile-email">{user.email}</dd></div>
          <div><dt className="eyebrow">Contact number</dt><dd className="mt-1" data-testid="profile-phone">{user.phone || "Not added"}</dd></div>
        </dl>
        <button data-testid="profile-edit-btn" onClick={() => { setForm({ full_name: user.full_name, phone: user.phone || "" }); setEditing(true); }}
          className="h-10 px-4 inline-flex items-center gap-2 border border-[#121417] text-sm hover:bg-[#121417] hover:text-white transition-colors">
          <Pencil className="h-4 w-4" /> Edit details
        </button>
      </section>
    );
  }

  return (
    <form onSubmit={save} data-testid="profile-form" className="mt-10 bg-white border border-[#E4E1D9] p-6 space-y-5">
      <div className="grid sm:grid-cols-2 gap-5">
        <Field label="Full name" required>
          <input data-testid="profile-input-name" required minLength={2} value={form.full_name}
            onChange={(e) => setForm({ ...form, full_name: e.target.value })} className="field-input" />
        </Field>
        <Field label="Contact number" hint="Optional">
          <input data-testid="profile-input-phone" type="tel" value={form.phone}
            onChange={(e) => setForm({ ...form, phone: e.target.value })} className="field-input" placeholder="07…" />
        </Field>
      </div>
      <p className="text-xs text-[#847F77]">Your email ({user.email}) is used to sign in and can't be changed here.</p>
      <div className="flex gap-3">
        <SubmitButton loading={loading} testId="profile-save-btn">Save details</SubmitButton>
        <button type="button" data-testid="profile-cancel-btn" onClick={() => setEditing(false)}
          className="h-12 px-6 border border-[#E4E1D9] text-sm hover:border-[#121417]">Cancel</button>
      </div>
    </form>
  );
};
